import { CHOOSE_FUNDING_REASON, topUpChosenReason } from './overBalanceCopy';
import type { FundingChoice } from './invoicePanel';
import type { InvoicingCandidate, TopUpPosting } from '../types/agreements.types';

export const EMPTY_SELECTION_REASON = 'Select at least one line to invoice.';

export const NO_INVOICING_DEALER_REASON =
    'No invoicing dealer is available for this product in your security groups.';

export const CANDIDATES_LOAD_FAILED_REASON = 'Failed to load invoicing dealers.';

export const AGREEMENT_INACTIVE_REASON = 'This agreement is not active.';

export const TOP_UP_RECORDING_REASON = 'Waiting for the payment to finish recording.';

export interface SubmitGates {
    selectionEmpty: boolean;
    candidatesLoading: boolean;
    candidatesError: boolean;
    candidatesGated: boolean;
    candidatesEmpty: boolean;
    agreementActive: boolean;
    balanceUnreadableReason: string | null;
    overBalance: boolean;
    fundingChoice: FundingChoice | null;
    recordedTopUpAmount: string | null;
    topUpPosting: TopUpPosting;
    authorisationReason: string | null;
    topUpPending: boolean;
    isPending: boolean;
}

function overBalanceReason({
    overBalance,
    fundingChoice,
    recordedTopUpAmount,
    topUpPosting,
    authorisationReason,
}: SubmitGates): string | null {
    if (!overBalance) return null;
    if (fundingChoice === null) return CHOOSE_FUNDING_REASON;
    if (fundingChoice === 'top_up') return topUpChosenReason(recordedTopUpAmount, topUpPosting);
    return authorisationReason;
}

function candidatesSettledEmpty(gates: SubmitGates): boolean {
    return gates.candidatesEmpty && !gates.candidatesLoading && !gates.candidatesError && !gates.candidatesGated;
}

export function submitDisabledReason(gates: SubmitGates): string | null {
    if (candidatesSettledEmpty(gates)) return NO_INVOICING_DEALER_REASON;
    if (gates.selectionEmpty) return EMPTY_SELECTION_REASON;
    if (gates.candidatesLoading) return 'Loading invoicing dealers.';
    if (gates.candidatesError) return CANDIDATES_LOAD_FAILED_REASON;
    if (gates.candidatesGated) return 'You do not have permission to list invoicing dealers.';
    if (!gates.agreementActive) return AGREEMENT_INACTIVE_REASON;
    if (gates.balanceUnreadableReason !== null) return gates.balanceUnreadableReason;
    if (gates.topUpPending) return TOP_UP_RECORDING_REASON;
    const fundingReason = overBalanceReason(gates);
    if (fundingReason !== null) return fundingReason;
    if (gates.isPending) return 'Submitting.';
    return null;
}

export function defaultInvoicingDealerId(candidates: InvoicingCandidate[] | undefined): string | null {
    return candidates?.length === 1 ? candidates[0].id : null;
}
